"use strict";
/*
 * Created on 10 11 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var moment = require("moment");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");

var VATRate_1 = require("./VATRate");
/**
 * VAT
 *
 * @author JMe
 */


var VAT =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(VAT, _DomainObject_1$Domai);

  /**
   * @param id the internal id
   * @param externalId the external id
   * @param name
   * @param shortName
   * @param rates vat rates
   */
  function VAT(id, externalId, name, shortName) {
    var _this;

    var rates = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : immutable_1.List();

    _classCallCheck(this, VAT);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VAT).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    _this.shortName = shortName;
    _this.rates = rates;
    return _this;
  }
  /**
   * Adds given rate to rates. If there is some rate with same {@link VAT.validFrom}, it is updated.
   * @param vatRate the vat rate
   * @returns updated VAT
   */


  _createClass(VAT, [{
    key: "addRate",
    value: function addRate(vatRate) {
      return this.copy('rates', this.removeRate(vatRate).rates.push(vatRate));
    }
    /**
     * Removes given rate from rates (based on validFrom).
     * @param vatRate the vat rate
     * @returns updated VAT
     */

  }, {
    key: "removeRate",
    value: function removeRate(vatRate) {
      if (this.rates.size === 0) {
        return this;
      }

      var index = this.rates.findIndex(function (r) {
        return r.validFrom.isSame(vatRate.validFrom);
      });
      return index === -1 ? this : this.copy('rates', this.rates.remove(index));
    }
    /**
     * @returns rate which is valid to given date
     */

  }, {
    key: "getActiveRate",
    value: function getActiveRate(date) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      date = utils_1.Utils.isValueMissing(date) ? moment.utc() : date; // HERE !!!

      var rates = this.rates.filter(function (item) {
        return date.isSameOrAfter(item.validFrom) && date.isSameOrBefore(item.validTo || date);
      });

      if (strict && rates.size !== 1) {
        throw new Error("Only one VAT rate can be valid at given time '".concat(date, "' and it should exist. Found ").concat(rates.size, " rates for VAT ").concat(this.id, " (").concat(this.shortName, ")"));
      }

      if (!strict && rates.isEmpty()) {
        throw new Error("VAT rate of VAT '".concat(this.id, "' for given time '").concat(date, "' does not exist!"));
      }

      return rates.get(0);
    }
  }]);

  return VAT;
}(DomainObject_1.DomainObject);

exports.VAT = VAT; // tslint:disable-next-line:member-ordering

VAT.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(VAT.name);
  return {
    id: builder.id('id'),
    externalId: builder.id('externalId'),
    name: builder.str('name'),
    shortName: builder.str('shortName'),
    rates: builder.listOf(builder.obj('rates', VATRate_1.VATRate.schema, function (mat) {
      return new VATRate_1.VATRate(mat.validFrom, mat.validTo, mat.rate);
    }))
  };
}();